export default "__VITE_ASSET__07d695f8__"